import React, { Component } from 'react'
import { withRouter } from 'react-router-dom'
import AuthenticatedPage from '../../../../containers/AuthenticatedPage'
import Table, { Row, Cell, Header } from '../../../../components/Table'
import Toggle from '../../../../components/Form/Inputs/Toggle'
import API from '../../../../lib/api'
import { APG_GATEWAY_HOST } from '../../../../config/app'
import './style.css'

class TUList extends Component {
    constructor(props) {
        super(props)
        const picklistId = this.props.match.params.picklistId

        this.state = {
            picklistId,
            tuItems: [],
            loading: true,
            error: null,
        }
    }

    componentDidMount() {
        this.fetchTUList()
    }

    fetchTUList = () => {
        const { picklistId } = this.state
        this.setState({ loading: true, error: null })

        const api = new API({
            url: `${APG_GATEWAY_HOST}/seller-order-service/picklists/admin/${picklistId}`
        })

        api.get({})
            .then(response => {
                const body = response || {}
                const actualData = body.data || body || {}

                let tuItems = []
                if (actualData.parcels && Array.isArray(actualData.parcels)) {
                    tuItems = actualData.parcels.map(parcel => ({
                        id: parcel.trackingID,
                        tuNumber: parcel.trackingID,
                        storageType: parcel.storageType,
                        submitted: true // Default to true as per user request
                    }))
                }

                this.setState({
                    tuItems,
                    loading: false
                })
            })
            .catch(error => {
                console.error('Error fetching TU list:', error)
                this.setState({
                    loading: false,
                    error: error.message || 'Failed to fetch TU list'
                })
            })
    }

    handleToggleSubmit = (tuId, checked) => {
        const updatedItems = this.state.tuItems.map(item =>
            item.id === tuId ? { ...item, submitted: checked } : item
        )
        this.setState({ tuItems: updatedItems })
    }

    handleBack = () => {
        this.props.history.push('/marketplace/picker-admin')
    }

    render() {
        const { menu } = this.props
        const { picklistId, tuItems, loading, error } = this.state

        return (
            <AuthenticatedPage menu={menu} className="tu-list-page">
                <div className="page-header">
                    <div className="header-left">
                        <button className="back-button" onClick={this.handleBack}>
                            ←
                        </button>
                        <h1 className="page-title">Picklist Number: {picklistId}</h1>
                    </div>
                </div>

                <div className="table-container">
                    {loading ? (
                        <div className="loading-state">Loading TU items...</div>
                    ) : error ? (
                        <div className="error-state">{error}</div>
                    ) : tuItems.length > 0 ? (
                        <Table>
                            <Header>
                                <Cell>TU Number</Cell>
                                <Cell>Storage Type</Cell>
                                <Cell>Submitted Status</Cell>
                            </Header>
                            {tuItems.map((item) => (
                                <Row key={item.id}>
                                    <Cell>{item.tuNumber}</Cell>
                                    <Cell>{item.storageType}</Cell>
                                    <Cell>
                                        <div className="tu-toggle-wrapper">
                                            <Toggle
                                                name={`tu-submit-${item.id}`}
                                                value={item.submitted}
                                                icons={false}
                                                onChange={(checked) => {
                                                    this.handleToggleSubmit(item.id, checked)
                                                }}
                                            />
                                        </div>
                                    </Cell>
                                </Row>
                            ))}
                        </Table>
                    ) : (
                        <div className="empty-state">No TU items found for this picklist</div>
                    )}
                </div>
            </AuthenticatedPage>
        )
    }
}

export default withRouter(TUList)
